import { themeColor } from "./_helpers";

/** JD import menu — maps to original raw palette colors (purple / orange / blue). */
export const importMenuTokens = {
  menuBg: themeColor({
    base: "{colors.white}",
    _themeBlack: "{colors.dark.800}",
    _themeWhite: "{colors.white}",
  }),
  menuBorder: themeColor({
    base: "{colors.neutral.200}",
    _themeBlack: "{colors.whiteAlpha.300}",
    _themeWhite: "{colors.neutral.200}",
  }),
  itemHoverBg: themeColor({
    base: "{colors.neutral.50}",
    _themeBlack: "{colors.whiteAlpha.100}",
    _themeWhite: "{colors.neutral.100}",
  }),
  titleFg: themeColor({
    base: "{colors.neutral.800}",
    _themeBlack: "{colors.white}",
    _themeWhite: "{colors.neutral.800}",
  }),
  descriptionFg: themeColor({
    base: "{colors.neutral.500}",
    _themeBlack: "{colors.neutral.400}",
    _themeWhite: "{colors.neutral.500}",
  }),
  aiIconBg: themeColor({
    base: "{colors.purple.50}",
    _themeBlack: "{colors.purple.900}",
    _themeWhite: "{colors.purple.50}",
  }),
  aiIconFg: themeColor({
    base: "{colors.purple.500}",
    _themeBlack: "{colors.purple.400}",
    _themeWhite: "{colors.purple.500}",
  }),
  badgeBg: themeColor({
    base: "{colors.purple.50}",
    _themeBlack: "{colors.purple.900}",
    _themeWhite: "{colors.purple.50}",
  }),
  badgeFg: themeColor({
    base: "{colors.purple.500}",
    _themeBlack: "{colors.purple.400}",
    _themeWhite: "{colors.purple.500}",
  }),
  uploadIconBg: themeColor({
    base: "{colors.orange.50}",
    _themeBlack: "{colors.orange.900}",
    _themeWhite: "{colors.orange.50}",
  }),
  uploadIconFg: themeColor({
    base: "{colors.orange.500}",
    _themeBlack: "{colors.orange.400}",
    _themeWhite: "{colors.orange.500}",
  }),
  webIconBg: themeColor({
    base: "{colors.blue.50}",
    _themeBlack: "{colors.blue.900}",
    _themeWhite: "{colors.blue.50}",
  }),
  webIconFg: themeColor({
    base: "{colors.blue.500}",
    _themeBlack: "{colors.blue.400}",
    _themeWhite: "{colors.blue.500}",
  }),
};
